import {
  locationIdFormat,
  productIdFormat,
} from "@redotech/redo-ids-cockroach";
import * as z from "zod";

export const getLocationsWithUnfulfilledOrders = {
  name: "getLocationsWithUnfulfilledOrders" as const,
  input: z.object({
    productIds: z.array(productIdFormat.schema),
    locationIds: z.array(locationIdFormat.schema),
  }),
  output: z.object({ locationIds: z.array(locationIdFormat.schema) }),
};
